import {
  defaultFont,
  grayColor,
  warningColor,
  lightBlueColor,
  dangerColor,
} from "assets/jss/material-dashboard-pro-react.js";

import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.js";

const shippingAddressStyle = (theme) => ({
  ...buttonStyle,
  contactsContainer: {
    /*    backgroundColor: "black",
        paddingTop: "20px",
        minHeight:'100vh'*/
    marginTop: "-30px",
  },
  container: {
    [theme.breakpoints.up("md")]: {
      maxWidth: "700px",
      margin: "auto",
    },
  },
  underline: {},
  card: {
    [theme.breakpoints.down("sm")]: {
      boxShadow: "none",
    },
  },
  title: {
    fontFamily: "'Archivo Narrow', sans-serif",
    fontSize: "23px",
    color: "#555555",
    fontWeight: "bold",
    margin: 0,
  },
  checkboxAndRadio: {
    marginTop: "15px",
    fontFamily: "'Archivo Narrow', sans-serif",
    fontSize: "17px",
    color: "#9b9b9b",
    display: "flex",
  },
  buttonBigTextMenu: {
    fontSize: "15px",
    fontFamily: "'Archivo Narrow', sans-serif",
    color: warningColor[0],
    lineHeight: "20px",
    fontWeight: "bold",
  },
  containerButtons: {
    marginBottom: "40px",
  },
  buttonTextNormal: {
    fontSize: "15px",
    fontFamily: "'Archivo Narrow', sans-serif",
    color: "white",
    lineHeight: "20px",
    fontWeight: "bold",
  },
  disabledLink: {
    pointerEvents: "none",
  },

  // DATE INPUT
  formControl: {
    width: "100%",
    margin: "0 0 17px 0",
    paddingTop: "27px",
    position: "relative",
    verticalAlign: "unset",
    borderBottom: "solid 1px #dadada",
    "& svg,& .fab,& .far,& .fal,& .fas,& .material-icons": {
      color: grayColor[14],
    },
  },
  labelRoot: {
    ...defaultFont,
    color: grayColor[3] + " !important",
    fontWeight: "400",
    fontSize: "13px",
    lineHeight: "1.42857",
    top: "10px",
    letterSpacing: "unset",
    "& + $underline": {
      marginTop: "0px",
    },
  },
  containerInput: {
    width: "100%",
    paddingTop: "27px",
    borderBottom: "none",
  },
  input: {
    border: 0,
    opacity: 1,
    fontSize: "14px",
    color: "#495057",
    // fontFamily: "Roboto",
    fontWeight: 400,
    linHeight: 1.42857,
    width: "100%",
  },
  chooseIconLabel: {
    fontSize: "16px",
    lineHeight: "30px",
    color: "#929292",
    fontweight: "bold",
    fontStyle: "italic",
    float: "left",
  },
  buttonTime: {
    padding: 0,
    textAlign: "center",
    width: "100%",
    color: lightBlueColor,
    // backgroundColor: "white",
    height: "36px",
    borderRadius: "5px",
    fontSize: "15px",
    fontFamily: "'Archivo Narrow', sans-serif",
    border: "solid 1px #ececeb",
    borderBottom: 0,
  },
  buttonSelect: {
    backgroundColor: warningColor[0],
    color: warningColor[0],
  },
  buttonSmall: {
    width: "24px",
    height: "24px",
    borderRadius: "12px",
    border: "solid 1px",
    borderColor: lightBlueColor,
    padding: "0px",
    color: lightBlueColor,
    backgroundColor: "white",
    "&:hover": {
      color: lightBlueColor,
      backgroundColor: "rgba(74,74,74,0.1)",
    },
    "&:focus": {
      backgroundColor: "white",
      color: lightBlueColor,
    },
  },
  labelRootError: {
    color: dangerColor[0] + " !important",
  },
  labelRootErrorCardRepetition: {
    color: dangerColor[0] + " !important",
    textAlign: "center",
  },
  helpTextClasses: {
    fontWeight: 300,
    marginTop: "36px",
  },
  buttonBack: {
    width: "36px",
    height: "36px",
    borderRadius: "18px",
    border: "none",
    padding: "0px",
    color: "rgba(74,74,74, 1)",
    backgroundColor: "white",
    float: "left",
    marginRight: "5px",
    "&:hover": {
      backgroundColor: "rgba(74,74,74,0.1)",
    },
    "&:focus": {
      backgroundColor: "white",
    },
  },
  minTotal: {
    // backgroundColor: "#cbcbcb",
    textAlign: "center",
    padding: "20px",
    fontSize: "15px",
    fontFamily: "'Archivo Narrow', sans-serif",
  },
});

export default shippingAddressStyle;
